import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  emptyInputSchema,
  preferencesSchema,
  profileSchema,
  updateProfileInputSchema,
  uploadAvatarInputSchema,
} from "./account.schemas.ts";

export const accountTrpcContract = defineTrpcContract("account", {
  profile: query({ input: emptyInputSchema, output: profileSchema }),
  updateProfile: mutation({ input: updateProfileInputSchema, output: profileSchema }),
  uploadAvatar: mutation({ input: uploadAvatarInputSchema, output: profileSchema }),
  removeAvatar: mutation({ input: emptyInputSchema, output: profileSchema }),
  updatePreferences: mutation({ input: preferencesSchema, output: profileSchema }),
});
